type AudioDevicesOptionsProps = {
    devices: MediaDeviceInfo[];
};

type VideoDevicesOptionsProps = {
    devices: MediaDeviceInfo[];
};

type DevicesOption = {
    label: string;
    value: string;
};

type ActiveDeviceProps = {
    devices: MediaDeviceInfo[];
    currentDeviceId?: string;
};

export const getAudioDevicesOptions = ({ devices }: AudioDevicesOptionsProps): DevicesOption[] => {
    return devices
        .filter(({ deviceId }) => deviceId !== 'default')
        .map(({ deviceId, label }) => {
            return { label, value: deviceId };
        });
};

export const getActiveAudioDevice = ({ devices, currentDeviceId }: ActiveDeviceProps) => {
    const realDevices = devices.filter(({ deviceId }) => deviceId !== 'default');
    const activeDevice = realDevices.find(({ deviceId }, i) => {
        // В Chrome есть устройство по-умолчанию, неявно выбрано оно.
        const isDefault = !currentDeviceId || currentDeviceId === 'default';
        // Браузеры неявно выбирают первое устройство в списке.
        const isFirstDevice = i === 0;
        const isNotDefaultDeviceActive = deviceId === currentDeviceId;
        const active = isDefault ? isFirstDevice : isNotDefaultDeviceActive;
        return active;
    });
    return activeDevice ?? realDevices[0] ?? devices[0];
};

export const getVideoDevicesOptions = ({ devices }: VideoDevicesOptionsProps): DevicesOption[] => {
    return devices.map(({ deviceId, label }) => ({ label, value: deviceId }));
};

export const getActiveVideoDevice = ({ devices, currentDeviceId }: ActiveDeviceProps) => {
    const activeDevice = devices.find(({ deviceId }, i) => {
        const isDefault = i === 0 && !currentDeviceId;
        const active = deviceId === currentDeviceId || isDefault;
        return active;
    });
    return activeDevice ?? devices[0];
};
